import { Box, Flex, NumericalMarker, Typography } from '@coolblue-development/freddy';

type Props = {
  index?: number;
  title: string;
  description?: string;
};

export default function SectionTitle({ index, title, description }: Props) {
  return (
    <Flex alignItems={description ? 'flex-start' : 'center'} gap={300}>
      {index !== undefined && <NumericalMarker>{index}</NumericalMarker>}
      <Box>
        <Typography variant='h2' m={0}>
          {title}
        </Typography>
        {description && <Typography mt={100}>{description}</Typography>}
      </Box>
    </Flex>
  );
}
